<!-- MFITTで発車1分後を過ぎて引き換え済みの取り消しをした場合 -->
<template>
  <ItemDialog ref="canNotCancelAfterDeparture" image-type="alert">
    <template #content-area>
      <p class="text-center">取り消し期限を過ぎたため取り消しはできません。</p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogCanNotCancelAfterDeparture",
  setup() {
    const canNotCancelAfterDeparture = ref(null);

    const openDialog = () => {
      canNotCancelAfterDeparture.value.open();
    };

    const closeDialog = () => {
      canNotCancelAfterDeparture.value.close();
    };

    return {
      canNotCancelAfterDeparture,
      openDialog,
      closeDialog,
    };
  },
};
</script>
